import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appConfirmPassword]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: ConfirmPasswordDirective, multi: true }]
})
export class ConfirmPasswordDirective implements Validator {

  @Input('appConfirmPassword') passwordControl: AbstractControl | null = null;
  private subscription: Subscription | null = null;

  ngOnInit() {
    if (this.passwordControl) {
      this.subscription = this.passwordControl.valueChanges.subscribe(() => {
        if (this.passwordControl?.parent) {
          this.passwordControl.parent.get('confirmPassword')?.updateValueAndValidity();
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.passwordControl) {
      return null;
    }
    const confirmPassword = control.value;
    const password = this.passwordControl.value;
    if (password !== confirmPassword) {
      control.setErrors({ confirmPasswordMissMatch: true });
      return { confirmPasswordMissMatch: true };
    } else {
      control.setErrors(null);
      return null;
    }
  }
}
